module.exports = __webpack_public_path__ + "rss_podcasts-e7340e8820c3416084a5.svg";